export default "__VITE_ASSET__4a828f6e__"